import { render, staticRenderFns } from "./kapor-form-success.vue?vue&type=template&id=356df4d4&lang=pug"
import script from "./kapor-form-success.vue?vue&type=script&lang=js"
export * from "./kapor-form-success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports